import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcMobileDeviceSecurity = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M3 2.5A1.5 1.5 0 0 1 4.5 1h11A1.5 1.5 0 0 1 17 2.5v2.606l-2 .25V3H5v15h9.269c.787.66 1.568 1.148 2.04 1.422.22.129.453.23.691.305V21.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 3 21.5v-19Zm7 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M14 8.883a1 1 0 0 1 .876-.992l2.876-.36a2 2 0 0 1 .496 0l2.876.36a1 1 0 0 1 .876.992V13c0 1.987-2.527 3.658-3.564 4.26a.862.862 0 0 1-.872 0C16.527 16.658 14 14.987 14 13V8.883Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcMobileDeviceSecurity");

export { IcMobileDeviceSecurity };
//# sourceMappingURL=ic-mobile-device-security.js.map
